import * as React from "react";
function SvgTriangleDown(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M32 8L16 24 0 8z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTriangleDown);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
